import React from 'react';
import { useSelector } from 'react-redux';
import { selectBadgesToShow } from '@debbie/cortex/dist/insights/selectors';
import { Badge } from '../';
import THEME from '../../theme';
import X from '../Icons/X';
const CaseFilterBadges = (props) => {
    const { caseFilter } = props;
    const badgesToShow = useSelector(selectBadgesToShow(caseFilter));
    return (React.createElement(React.Fragment, null, badgesToShow.map((badge, i) => (React.createElement(Badge, { key: i, theme: THEME.COLOR_PRIMARY, style: {
            cursor: 'pointer',
            margin: '0 5px 5px 0',
            lineHeight: '1.8em',
        }, onClick: badge.onDeactivate },
        typeof badge.label === 'function'
            ? // @ts-ignore
                badge.label(THEME.DATE_FORMAT)
            : badge.label,
        ' ',
        React.createElement(X, { style: { margin: '0.1em 0px -0.1em' } }))))));
};
export default CaseFilterBadges;
//# sourceMappingURL=CaseFilterBadges.js.map